import * as CryptoJS from 'crypto-js'
import http from './http-service'
import config from '../config/constant'
import environment from 'custom/config/environment'
import { store } from '../store'
import {
  SET_PROFILE_IMAGE_DETAILS,
} from '../store/constants'

const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse(environment.ENCRYPT_KEY)
export const encryptAES = (text) =>
  CryptoJS.AES.encrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString()

const postLogin = async (data) => {
  try {
    const reqParams = {
      ...data,
      password:encryptAES(data.password),
      requestId: 'LOGIN',
      channelType: 'CORPWEB',
      ipAddress: '0.0.0.0.0',
      language: 'en',
    }
    const response = await http.post(config.login, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const postResetPassword = async (data) => {
  try {
    const reqParams = {
      newPassword: encryptAES(data.newPassword),
      requestId: 'FORCECHANGEPWD',
    }
    const response = await http.post(config.forceChangePwd, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getUserDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.userProfile.userDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyUserDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.userProfile.userDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const postLogout = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'LOGOUT',
    }
    const response = await http.post(config.Logout, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const postChangePassword = async (data) => {
  try {
    const reqParams = {
      ...data,
    }
    const response = await http.post(config.changePassword, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getRights = async (data) => {
  try {
    const reqParams = {
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.getRights, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAllMenus = async (data) => {
  try {
    const reqParams = {
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.getAllMenus, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getProfileImage = async () => {
  const { app } = store.getState()
  try {
    const reqParams = {
      requestId: 'GETPROFILEIMAGE',
      //username: app.username,
    }
    const response = await http.post(config.userProfile.getImage, reqParams)
    store.dispatch({ type: SET_PROFILE_IMAGE_DETAILS, payload: response.data['imageData'] })
    return response.data 
  } catch (err) {
    return Promise.reject(err)
  }
}

export const uploadProfileImage = async (imageData) => {
  const { app } = store.getState()
  try {
    const reqParams = {
      requestId: 'UPLOADUUSERPROFILE',
      //username: app.username,
      imageData,
    }
    console.log('request param is', reqParams)
    const response = await http.post(config.userProfile.uploadProfileImage, reqParams)
    store.dispatch({ type: SET_PROFILE_IMAGE_DETAILS, payload: imageData })
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const deleteProfileImage = async (data) => {
  const { app } = store.getState()
  try {
    const reqParams = {
      requestId: 'DELETEPROFILEIMAGE',
      //username: app.username,
    }
    const response = await http.post(config.userProfile.removeProfileImage, reqParams)
    store.dispatch({ type: SET_PROFILE_IMAGE_DETAILS, payload: null })
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyLoginOTP = async (data) => {
  try {
    const reqParams = {
      requestId: 'LOGIN',
      ...data
    }
    const response = await http.post(config.verifyLoginOTP, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const dateFormat = (date) => {
  const selectedDate = new Date(date)
  const dd = selectedDate.getDate()
  const mm = selectedDate.getMonth() + 1
  const yyyy = selectedDate.getFullYear()
  const convertedDate = `${yyyy}-${mm < 10 ? '0' + mm : mm}-${dd < 10 ? '0' + dd : dd}`
  return convertedDate
}

export const forgetPwdConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FORGOTPASSREQ',
    }
    const response = await http.post(config.forgotPassword.confirmPassword, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const forgetPwdCriteria = async (data) => {
  try {
    const reqParams = {
      ...data,
      password: encryptAES(data.password),
    }
    const response = await http.post(config.forgotPassword.forgotPasswordCriteria, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export const forgetPwdVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      dob: dateFormat(data.dob),
      requestId: 'FORGOTPASSVRFY',
    }
    const response = await http.post(config.forgotPassword.forgotPasswordVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const AuthService = {
  postLogin,
  postLogout,
  postChangePassword,
  getRights,
  getAllMenus,
  verifyLoginOTP,
  getUserDetails,
  verifyUserDetails,
  getProfileImage,
  uploadProfileImage,
  deleteProfileImage,
  forgetPwdVerify,
  forgetPwdCriteria,
  forgetPwdConfirm,
  postResetPassword
}

export default AuthService
